import { getRaasContextOptional } from "./context";

/**
 * Resolves whether SDK console output is enabled.
 * Pass `explicitVerbose` during `init()` validation before context exists; otherwise reads from context.
 */
const resolveVerbose = (explicitVerbose?: boolean): boolean => {
  if (explicitVerbose !== undefined) return explicitVerbose;
  return getRaasContextOptional()?.config.verbose ?? false;
};

export const sdkLog = (message: string, explicitVerbose?: boolean): void => {
  if (!resolveVerbose(explicitVerbose)) return;
  console.log(`[Raas] ${message}`);
};

export const sdkError = (
  payload: unknown,
  explicitVerbose?: boolean,
): void => {
  if (!resolveVerbose(explicitVerbose)) return;
  console.error(payload);
};
